var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 9.75L11.7188 5.125C11.8438 4.96875 12.0938 4.96875 12.25 5.125L12.8438 5.75C13 5.875 13 6.125 12.8438 6.28125L9.15625 10L12.8438 13.75C13 13.9062 13 14.125 12.8438 14.2812L12.25 14.9062C12.0938 15.0625 11.8438 15.0625 11.7188 14.9062L7.125 10.2812C6.96875 10.125 6.96875 9.90625 7.125 9.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.a3d866c58b7ff872a3b7c24592f28f94.svg";
export { ForwardRef as ReactComponent };